<template>
  <base-section id="about-our-products">
    <base-section-heading
      color="primary"
      title="About our Products"
    />

    <base-section-heading
      color="primary"
      title="Jungheinrich"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cardsjh"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>

    <base-section-heading
      color="primary"
      title="Manitou"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'Backhoe Loader',
          subtitle: 'Fuel Efficient',
          text: 'Manitou Backhoe Loaders are designed to perform relentlessly with ease of functionality. We are constantly developing and advancing our technologies to ensure that our Backhoe Loaders provide power and performance for every kind of digging and excavating application.',
          callout: '01',
          src: require('@/assets/bhl1.webp'),
          link: 'https://manitouindia.com/',
        },
        {
          title: 'Skid Steer Loader',
          subtitle: 'Compact and Powerful',
          text: 'Manitou Skid Steer Loaders are designed for excellence, with the perfect amalgamation of performance and safety. We are constantly innovating our technologies to ensure that our Skid Steer Loaders provide versatility with a powerful performance across terrains.',
          callout: '02',
          src: require('@/assets/ssl4.webp'),
          link: 'https://manitouindia.com/',
        },
        {
          title: 'Telescopic Handler',
          subtitle: 'Versatile',
          text: 'Manitou Telehandlers are designed keeping in mind, versatility, efficiency, simplicity, ease of access and unhindered workflow even in the most difficult conditions and terrains. They are ultra-manageable machines with multiple steering modes for complex maneuvers. Equipped with a telescopic boom, they save time on a daily basis when handling all types of loads in height and outreach.',
          callout: '03',
          src: require('@/assets/tl2.webp'),
          link: 'https://manitouindia.com/',
        },
      ],
      cardsjh: [
        {
          title: 'Pallet Trucks',
          text: 'With our wide range of pallet trucks, we provide the perfect product for your individual requirements. If you transport large quantities of goods and heavy loads across short distances on a daily basis, you will reap the benefits of using our manual hand pallet trucks. Thanks to their high load capacity and outstanding manoeuvrability, these pallet trucks provide invaluable assistance in any warehouse. If your goods are more difficult to lift and transport, you should step up to one of our specialist electric pallet trucks.',
          callout: '01',
          src: require('@/assets/pallettrucks.webp'),
          link: 'https://www.jungheinrich.in/products/new-trucks/pallet-trucks',
        },
        {
          title: 'Stackers',
          text: 'Stacker trucks are ideal for transporting pallets quickly and safely from A to B, but can also lift loads up to raised platforms. We offer the perfect solution for any transport distance or lift height. We are also happy to advise you regarding financing options for your electric stacker trucks.',
          callout: '02',
          src: require('@/assets/stackers.webp'),
          link: 'https://www.jungheinrich.in/products/new-trucks/pallet-trucks/electric-pallet-stackers',
        },
        {
          title: 'Forklifts',
          text: 'Our forklift trucks are perfect all-rounders that can be used in virtually any warehouse. They are also extremely manoeuvrable and transport your goods with the utmost reliability both indoors and outdoors. Thanks to their high capacity, our counterbalance trucks can easily handle very heavy loads weighing up to nine tons.',
          callout: '03',
          src: require('@/assets/forklifts.webp'),
          link: 'https://www.jungheinrich.in/products/new-trucks/forklift-trucks',
        },
        {
          title: 'Reach Trucks',
          text: 'For over sixty years, our reach trucks have been delivering reliable service and performance in warehouses across the globe. Particularly in confined conditions, our electric reach trucks set new benchmarks thanks to their compact construction and outstanding lifting capacity.',
          callout: '04',
          src: require('@/assets/reachtrucks.webp'),
          link: 'https://www.jungheinrich.in/products/new-trucks/reach-trucks',
        },
        {
          title: 'Very Narrow Aisle Trucks (VNA)',
          text: 'With our high rack stackers, you can stack pallets or pick individual articles with consummate ease. They impress with their throughput performance and space utilisation – both significant advantages in the face of growing costs and product variety in the world of logistics.',
          callout: '05',
          src: require('@/assets/vna.webp'),
          link: 'https://www.jungheinrich.in/products/new-trucks/very-narrow-aisle-truck',
        },
      ],
    }),
  }
</script>
